const ACCESS_TOKEN_KEY = 'pptcreate_access_token';

export function getAccessToken(): string | null {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function clearAccessToken(): void {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
}

/**
 * OAuth and email login flows may land with `?accessToken=` in the URL.
 * Persist it once, then strip it from the address bar.
 */
export function captureAccessTokenFromUrl(): boolean {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('accessToken');
  if (!token) {
    return false;
  }

  setAccessToken(token);
  params.delete('accessToken');
  const nextSearch = params.toString();
  const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
  window.history.replaceState({}, '', nextUrl);
  return true;
}
